import {TimeZoneStore} from '../../constants/actionType';

const initialState = {
  isAutoSync: true,
  geoArea: '',
  region: '',
  date: null,
  time: null,

  /*
  {
    isAutoSync: true,
    geoArea: '',
    region: '',
    date: new Date().getDate(),
    time: new Date().getTime(),
  }
   */
  origin: null,
};

export default function timeZoneStore(state = initialState, action = {}) {
  switch (action.type) {
    case TimeZoneStore.SET_IS_AUTO_SYNC:
      return {...state, isAutoSync: action.value};
    case TimeZoneStore.SET_GEO_AREA:
      return {...state, geoArea: action.value};
    case TimeZoneStore.SET_REGION:
      return {...state, region: action.value};
    case TimeZoneStore.SET_DATE:
      return {...state, date: action.value};
    case TimeZoneStore.SET_TIME:
      return {...state, time: action.value};
    case TimeZoneStore.SET_ORIGIN:
      return {...state, origin: action.value};
    case TimeZoneStore.SET_INIT:
      return {
        ...state,
        isAutoSync: action.isAutoSync,
        geoArea: action.geoArea,
        region: action.region,
        date: action.date,
        time: action.time,
        origin: action.origin,
      };
    case TimeZoneStore.SET_TIMEZONE:
      return {
        ...state,
        isAutoSync: action.isAutoSync,
        geoArea: action.geoArea,
        region: action.region,
        date: action.date,
        time: action.time,
      };
    case TimeZoneStore.RESET:
      return initialState;
    default:
      return state;
  }
}
